import {Typography} from '@mui/material'
import {FormattedMessage, useIntl} from 'react-intl'
import AppDialog from './AppDialog'
import Button from 'src/components-new/primitives/Button'

type WarningDialogNewProps = {
  onClose: () => void
}

export default function WarningDialogNew({onClose}: WarningDialogNewProps): JSX.Element {
  const intl = useIntl()

  return (
    <AppDialog
      actions={
        <Button onClick={onClose} variant="primary">
          <FormattedMessage id="warningDialogButton" />
        </Button>
      }
      onClose={onClose}
      open
      title={intl.formatMessage({id: 'warningDialogTitle'})}
    >
      <Typography variant="body1">
        <FormattedMessage id="warningDialogBody" />
      </Typography>
    </AppDialog>
  )
}
